"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Table = _interopRequireDefault(require("./Table.style"));

var _dec, _class, _class2, _temp;

let Table = (_dec = (0, _reactJss.default)(_Table.default), _dec(_class = (_temp = _class2 = class Table extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      columnSize: {}
    };
    this.tableRef = props.forwardRef || _react.default.createRef();
    this.handleColumnSize = this.handleColumnSize.bind(this);
  }

  getChildContext() {
    const {
      scrolled,
      visibility,
      paddingSize
    } = this.props;
    return {
      scrolled,
      visibility,
      paddingSize
    };
  }

  handleColumnSize(columnSize) {
    this.setState({
      columnSize
    });
  }

  renderTable(tableClasses, children) {
    return _react.default.createElement("div", {
      ref: this.tableRef,
      className: tableClasses
    }, _react.default.Children.map(children, child => _react.default.cloneElement(child, {
      getColumnSize: this.handleColumnSize,
      columnSize: this.state.columnSize
    })));
  }

  render() {
    const {
      className,
      classes,
      visibility,
      children,
      scrolled
    } = this.props;
    const tableClasses = (0, _clsx.default)(classes.table, {
      [`${className}`]: !scrolled
    }, {
      hidden: visibility === 'hidden'
    }, {
      disabled: visibility === 'disabled'
    });
    const tableWrapClasses = (0, _clsx.default)(classes.tableWrap, className, {
      hidden: visibility === 'hidden'
    }, {
      disabled: visibility === 'disabled'
    }, {
      scrolled
    });
    return scrolled ? _react.default.createElement("div", {
      className: tableWrapClasses
    }, this.renderTable(tableClasses, children)) : this.renderTable(tableClasses, children);
  }

}, (0, _defineProperty2.default)(_class2, "childContextTypes", {
  scrolled: _propTypes.default.bool,
  visibility: _propTypes.default.oneOf(['visible', 'disabled', 'hidden']),
  paddingSize: _propTypes.default.oneOf(['small', 'medium'])
}), _temp)) || _class);
Table.defaultProps = {
  visibility: 'visible',
  scrolled: false,
  paddingSize: 'medium'
};
var _default = Table;
exports.default = _default;